export interface ContactPresidentProps {
  enterpriseName: string;
  name: string;
  phone: string;
  email: string;
  subject: string;
  message: string;
  customerId?: string;
}

export const FileTypesAccept = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'application/pdf',
];

export const ContactDefault = {
  enterpriseName: "",
  name: "",
  phone: "",
  email: "",
  subject: "",
  message: "",
  customerId: ""
};


